import * as actionTypes from "./actionTypes";
import {
  getMyScheduleAPI,
  createMyScheduleAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  let duration = 5000;
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "INVALID_DATE":
      errorString = getLocalizedString("dateChangeRequestMustBeBetweenDates", { dateFrom: e.response?.data.dateFrom, dateTo: e.response?.data.dateTo });
      break;
    case "INVALID_MAX_WEEK_HOURS":
      errorString = getLocalizedString("scheduleChangeNotAllowedDueToExcessHours");
      duration = 15000;
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error", duration: duration }));
}

export const getMyScheduleAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getMyScheduleAPI();
    let data = response?.data?.data;
    let schedules = response?.data?.schedules;
    let openCalendar = response?.data?.openCalendar;
    let minDates = response?.data?.minDates;
    let weeklyHours = response?.data?.weeklyHours;
    let status = response?.data?.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: {
        data,
        schedules,
        openCalendar,
        minDates,
        weeklyHours,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const createMyScheduleAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE });
  try {
    let response = await createMyScheduleAPI(dataToSend);
    let data = response?.data?.data;
    let schedules = response?.data?.schedules;
    let status = response?.data?.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CREATE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CREATE_FULFILLED,
      payload: { data, schedules },
    });


    dispatch(openSnackbarAction({ msg: getLocalizedString("schedulesUpdatedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};